import React from 'react';
import { Table } from 'semantic-ui-react';
import { FitnessFuncContent, HeaderName } from '../userPageStyles';

const TargetedFitnessFuncBlock = React.memo(({ params }) => {
  return (
    <FitnessFuncContent>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <HeaderName>Σ К</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ Б</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ ЖБ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ РБ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ Ж</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ НЖ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ ННЖ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName> Σ У</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ ПУ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ СУ</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ кл в г</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ кал утро</HeaderName>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <HeaderName>Σ кал осн</HeaderName>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>{params && params.calories_target}</Table.Cell>
            <Table.Cell>{params && params.proteins_target}</Table.Cell>
            <Table.Cell>{params && params.animal_protein_target}</Table.Cell>
            <Table.Cell>{params && params.vegetable_protein_target}</Table.Cell>
            <Table.Cell>{params && params.fats_target}</Table.Cell>
            <Table.Cell>{params && params.saturated_fat_target}</Table.Cell>
            <Table.Cell>{params && params.unsaturated_fats_target}</Table.Cell>
            <Table.Cell>{params && params.carbohydrates_target}</Table.Cell>
            <Table.Cell>{params && params.simple_carbohydrates_target}</Table.Cell>
            <Table.Cell>{params && params.complex_carbohydrates_target}</Table.Cell>
            <Table.Cell>{params && params.cellulose}</Table.Cell>
            <Table.Cell>-</Table.Cell>
            <Table.Cell>-</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </FitnessFuncContent>
  );
});

export default TargetedFitnessFuncBlock;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/TargetedFitnessFuncBlock/index.jsx